import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useFirebase, isEmpty } from 'react-redux-firebase'
import { Container, Row, Col, Card, CardBody, CardHeader, Button, Spinner } from 'reactstrap'
import { Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import TopNavigation from '../TopNavigation'

// Shown on guest-enabled private routes when the visitor is not signed in at all.
// Offers login (returning to this route via state.from) or continuing as an
// anonymous Firebase user. An existing anonymous session passes straight through.
function GuestGate({ appconfig, location, children }) {
  const firebase = useFirebase()
  const history = useHistory()
  const { t } = useTranslation()
  const auth = useSelector((state) => state.firebase.auth)
  const [starting, setStarting] = useState(false)
  const [failed, setFailed] = useState(false)

  const isGuest = !isEmpty(auth) && auth.isAnonymous

  if (isGuest) {
    return children
  }

  const goLogin = () => {
    history.push(appconfig.pathPrefix + '/login', { from: location })
  }

  const continueAsGuest = async () => {
    setStarting(true)
    try {
      await firebase.auth().signInAnonymously()
      // auth state updates through the store; isGuest flips true and children render
    } catch (error) {
      // e.g. auth/operation-not-allowed when the provider is disabled;
      // show the error and leave the login button as the way forward
      setFailed(true)
      setStarting(false)
    }
  }

  return (
    <div className='full-page-background'>
      <TopNavigation />
      <Container className='login-dialog'>
        <Row>
          <Col md='5' className='mx-auto'>
            <Card>
              <CardHeader tag='h5'>{t('guest_checkout_title')}</CardHeader>
              <CardBody>
                <Button color='primary' block onClick={() => goLogin()}>
                  {t('kirjaudu')}
                </Button>
                <Button
                  color='secondary'
                  outline
                  block
                  disabled={starting}
                  style={{ marginTop: 10 }}
                  onClick={() => continueAsGuest()}
                >
                  {starting ? <Spinner size='sm' /> : t('guest_continue_without_account')}
                </Button>
                {failed ? (
                  <Typography variant='body2' color='error' style={{ marginTop: 10 }}>
                    {t('guest_error_generic')}
                  </Typography>
                ) : null}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default GuestGate
